'use client';

import { motion } from '@/libs';
import { useDrawerStore } from '@/stores';

import { Button } from '../../ui';

export const RegistrationExitConfirmation = () => {
  const clearPreventingComponent = useDrawerStore(
    (state) => state.clearPreventingComponent,
  );
  const forceCloseDrawerWithPreventClear = useDrawerStore(
    (state) => state.forceCloseDrawerWithPreventClear,
  );

  return (
    <motion.div
      data-cy="user-register-exit-confirmation"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="flex flex-col items-center gap-4 p-4"
    >
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Descartar cadastro?
        </h3>
        <p className="text-sm text-muted-foreground">
          Você ainda não concluiu a criação da sua conta. Se sair agora, os dados
          preenchidos serão perdidos.
        </p>
      </div>

      <div className="flex gap-3 w-full">
        <Button
          data-cy="user-register-exit-continue-button"
          onClick={clearPreventingComponent}
          variant="primary"
          className="flex-1 h-12 text-background text-sm"
        >
          Continuar cadastro
        </Button>

        <Button
          data-cy="user-register-exit-discard-button"
          variant="secondary"
          onClick={forceCloseDrawerWithPreventClear}
          className="flex-1 h-12 text-foreground hover:bg-error/10 hover:text-foreground/80 text-sm"
        >
          Sair mesmo assim
        </Button>
      </div>
    </motion.div>
  );
};
